import styled, { css } from 'styled-components';

export const ListItems = styled.ul`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    gap: 16px;
 
    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.lg}) {
      grid-template-columns: repeat(3, 1fr);
    }    

    @media (min-width: ${theme.v2.breakpoints.lgg}) {
      grid-template-columns: repeat(4, 1fr);
    }    
  `};
`;

export const Item = styled.li`
  ${({ theme, $itemHasHandler }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    border-radius: 16px;
    gap: 16px;
    cursor: ${$itemHasHandler ? 'pointer' : 'default'};
    transition: .3s;

    &:hover {
      border-color: ${theme.v2.colors.brand.primaryMedium};
      box-shadow: 0 0 20px 0 ${theme.v2.colors.brand.primaryMedium}33;
    }

    &:active {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-color: transparent;
      box-shadow: none;
    }
  `}
`;

export const ItemIcon = styled.img`
  width: 40px;
  height: 40px;
  display: block;
  margin-right: 12px;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`;

export const ItemName = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const ItemInfo = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowMedium};
  `}
`;

export const ItemArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
